import Empty from './Empty';

export default Empty;
export { Empty };
export type { EmptyProps } from './type';
